import { useEffect, useRef } from 'react';
import { useUsuario } from '../../context/usuarioContext';
import './dashboard.css';
import { Messages } from 'primereact/messages';
import { getEstadoConductorMessage } from '../../utils/messages/estadoConductor';
import ModulosGrid from '../../components/inicio/modulos-grid'

export default function Dashboard () {
  const { usuario, tienePermiso } = useUsuario();
  const messagesRef = useRef(null);
  
  const modulos = [
    { label: 'Inventario',       icon: 'pi pi-warehouse', path: '/app/inventario-tk', modulo: 'Inventario', permiso: 'ACCESO_MOD_INV' },
    { label: 'Taller Mecánico',  icon: 'pi pi-wrench',    path: '/app/taller', modulo: 'Taller Mecánico', permiso: 'ACCESO_MOD_MEC' },
    { label: 'Vehículos',        icon: 'pi pi-car',       path: '/app/panel-vehiculos', modulo: 'Panel Vehículos', permiso: 'ACCESO_MOD_VEH' },
    { label: 'Conductor',        icon: 'pi pi-user',      path: '/app/panel-conductor', modulo: 'Panel Conductor', permiso: 'ACCESO_MOD_CON' },
    { label: 'Prevención',       icon: 'pi pi-user',      path: '/app/panel-prevencion', modulo: 'Panel Prevención', permiso: 'ACCESO_MOD_PRE' },
    { label: 'Crear Usuario',    icon: 'pi pi-user-plus', path: '/app/gestion-personas/persona/crear-nuevo', modulo: 'Gestión de Personas', permiso: 'PER_REGISTRAR_PERSONA'},
    { label: 'Restablecer Contraseña', icon: 'pi pi-key', path: '/app/gestion-personas/usuario/administrar', modulo: 'Gestión de Personas', permiso: 'ACCESO_MOD_PER'},
  ]

  useEffect(() => {
    if (!messagesRef.current) return;
    messagesRef.current.clear();
    const message = getEstadoConductorMessage(usuario);
    if (message) { messagesRef.current.show(message); }
  }, [usuario]);

  return (
    <>
      <div className='notificacion-container'>
        <Messages ref={messagesRef} className='notificacion-msg'/>
      </div>
      
      {usuario ? (
        <>
        <div className="bienvenida-container">
          <h1 className="bienvenida-titulo">
            Bienvenid@, {usuario.nombre} {usuario.apellido_paterno} {usuario.apellido_materno}
          </h1>
          <p className="bienvenida-subtitulo">¡Que tengas una gran jornada!</p>
          <ModulosGrid modulos={modulos} tienePermiso={tienePermiso} />
        </div>
        </>
      ) : (
        <div className="bienvenida-container">
          <p className="bienvenida-subtitulo">No has iniciado sesión</p>
        </div>
      )}
    </>
  );
};
